import { useState, useMemo, useCallback } from "react";
import { isEqual } from "lodash";

import { ExpenseReportStatusQuickFilter } from "./interfaces";
import { EXPENSE_REPORT_STATUS } from "../../../utils/constants/constants";
import React from "react";

export const useExpenseReportStatusQuickFilter = (forManager?: boolean) => {
  const [quickFilter, setQuickFilter] = useState<ExpenseReportStatusQuickFilter>({
    expenseReportStatuses: {
      expenseReportStatusIds: forManager
        ? [EXPENSE_REPORT_STATUS.submitted.id, EXPENSE_REPORT_STATUS.approved.id]
        : [EXPENSE_REPORT_STATUS.draft.id, EXPENSE_REPORT_STATUS.returned_to_employee.id],
    },
  });

  const handleChangeQuickFilter = useCallback(
    (filter: keyof ExpenseReportStatusQuickFilter, value: ExpenseReportStatusQuickFilter["expenseReportStatuses"]) => {
      if (isEqual(value, quickFilter[filter])) return;
      setQuickFilter((state) => ({ ...state, [filter]: value }));
    },
    [quickFilter]
  );

  return {
    expenseReportStatusQuickFilter: quickFilter,
    setExpenseReportStatusQuickFilter: handleChangeQuickFilter,
  };
};
